import * as React from 'react';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { Newsletter } from '../../components/newsletter/Newsletter';
import { DefaultLayout } from '../../layout/default/DefaultLayout';

// noinspection JSUnusedGlobalSymbols
export default () => {
  // TODO: Add SEO props
  const seo = {
    description: '',
  };

  return (
    <DefaultLayout locale='en-US' seo={seo}>
      <HeadTitle title='Newsletter' />
      <Newsletter />
    </DefaultLayout>
  );
};
